import { IconButton } from "@/components/form"
import type { ObjectSchemaProperty } from "@/models"
import { faArrowDown, faArrowUp, faMinusCircle } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	columns: ObjectSchemaProperty[]
	changeColumnOrder(index1: number, index2: number): void
	removeColumn(index: number): void
}

const tableStyling = css`
	grid-template-columns: 1fr max-content max-content;
	width: 100%;
	td {
		display: flex;
		align-items: center;
	}

	td:nth-child(2) {
		gap: 0.35rem;
	}

	td:nth-child(3) {
		justify-content: center;
	}

	td div {
		display: flex;
	}
`

const ColumnManagerTable: ReactiveComponent<Props> = (props) => {
	return () => (
		<table class={["table small table-striped table-hover grid-table grid-table-bordered", tableStyling]}>
			<thead>
				<tr>
					<th>Column Name</th>
					<th>Move</th>
					<th> Remove </th>
				</tr>
			</thead>
			<tbody>
				{props.columns.map((column, index) => (
					<tr key={column.vueKey()}>
						<td>{column.formatName()}</td>
						<td class="d-flex">
							<IconButton
								class="btn btn-outline quick-button quick-edit-button mr-1"
								style="width: 4rem;"
								color="secondary"
								icon={faArrowUp}
								title="Move Up"
								onClick={() => props.changeColumnOrder(index, index - 1)}
								disabled={props.columns[0] === column}
							/>
							<IconButton
								class="btn btn-outline quick-button quick-edit-button mr-1"
								style="width: 4rem;"
								color="secondary"
								icon={faArrowDown}
								title="Move Down"
								onClick={() => props.changeColumnOrder(index, index + 1)}
								disabled={props.columns[props.columns.length - 1] === column}
							/>
						</td>
						<td>
							<IconButton
								class="btn btn-outline quick-button quick-edit-button mr-1"
								style="width: 4rem;"
								color="danger"
								icon={faMinusCircle}
								title="Remove Column"
								onClick={() => props.removeColumn(index)}
							/>
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}

export default defineComponent(ColumnManagerTable, inferProps<Props>())
